import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ChamadosService {

  api = environment.api;
  constructor(private http: HttpClient) { }

  getSuportes(){
    return this.http.get(`Chamado/getChamados`).toPromise();
  }

  getSuporteById(suporteId){
    return this.http.get(`Chamado/getChamadoId?chamadoId=${suporteId}`).toPromise();
  }
}
